import { render, staticRenderFns } from "./edit_goods_list.vue?vue&type=template&id=196aeb55&scoped=true"
import script from "./edit_goods_list.vue?vue&type=script&lang=js"
export * from "./edit_goods_list.vue?vue&type=script&lang=js"
import style0 from "./edit_goods_list.vue?vue&type=style&index=0&id=196aeb55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196aeb55",
  null
  
)

export default component.exports